import { cache } from "../persistence/cache";
import defaults from '../../constants'

/**
 * Extends userManager.get method to check if the requested user is already stored in the cache, and will use
 * the local version instead of making the call to the backend.
 * @param {function} originalFunction userManager.get method that will be wrapped with the previous cache check
 * @returns {function} A new get function that will check the local cache before making a network request without
 * changing the userManager.get method itself.
 */
export function fromMopsCache(originalFunction) {
  return async function(config = {}) {
    if (!config.avoidCache && this.localCache && this.localCache.mops) {
      let mops = await cache.get("mops", { database: "mops" });
      if (!mops) {
        mops = await originalFunction.call(this);
      }
      return mops;
    } else {
      return await originalFunction.call(this);
    }
  };
}

/**
 * Extends authenticationManager.login or authenticationManager.signup method to store the received data in the local cache after the network request.
 * @param {Function} originalFunction - Login or signup method that will be wrapped with the caching logic.
 * @returns {Function} A new login function that will store the received data in the cache without modifying
 * the login/signup method itself.
 */

export function toMopsCache(originalFunction) {
  return async function() {
    const response = await originalFunction.call(this);
    if (this.localCache && this.localCache.mops && response) {
      cache.set("mops", response, {
        database: "mops",
        expiresIn: this.allMopsCacheTime
      });
    }
    return response;
  };
}



/**
 * Extends userManager.get method to check if the requested user is already stored in the cache, and will use
 * the local version instead of making the call to the backend.
 * @param {function} originalFunction userManager.get method that will be wrapped with the previous cache check
 * @returns {function} A new get function that will check the local cache before making a network request without
 * changing the userManager.get method itself.
 */
 export function fromPaymentMethodCache(originalFunction) {
  return async function(planId) {
    if (defaults.localCache && defaults.localCache.paymentMethodDictionary) {
      let paymentMethodDictionary = await cache.get("paymentMethodDictionary", { database: "paymentMethodDictionary" });
      if (!(paymentMethodDictionary && paymentMethodDictionary[planId])) {
        paymentMethodDictionary = await originalFunction.call(this, planId);
      }
      return paymentMethodDictionary;
    } else {
      return await originalFunction.call(this, planId);
    }
  };
}

/**
 * Extends authenticationManager.login or authenticationManager.signup method to store the received data in the local cache after the network request.
 * @param {Function} originalFunction - Login or signup method that will be wrapped with the caching logic.
 * @returns {Function} A new login function that will store the received data in the cache without modifying
 * the login/signup method itself.
 */

export function toPaymentMethodCache(originalFunction) {
  return async function(planId) {
    const response = await originalFunction.call(this, planId);
    if (defaults.localCache && defaults.localCache.paymentMethodDictionary && response) {
      let existingData = await cache.get("paymentMethodDictionary", { database: "paymentMethodDictionary" });
      cache.set("paymentMethodDictionary", {...existingData, ...response}, {
        database: "paymentMethodDictionary",
        expiresIn: this.paymentMethodDictionaryCacheTime
      });
    }
    return response;
  };
}
